import { Controller } from "@hotwired/stimulus"

// The membership flow's create-account form (TMS-1655). Continue stays disabled until the form can
// succeed: a new account needs a password meeting the iMIS policy, typed the same twice; linking an
// existing one needs its password. Either way the terms must be agreed. A confirmation that has
// stopped matching what was typed above says so under the field, rather than waiting for submit.
// The server checks all of this again (Users::RegisterWithImisService).
const PASSWORD_POLICY = /^(?=.*[A-Za-z])(?=.*\d).{7,}$/

export default class extends Controller {
  static targets = ["password", "confirmation", "mismatch", "terms", "submit"]

  connect() {
    this.check()
  }

  check() {
    this.submitTarget.disabled = !(this.passwordReady() && this.termsTarget.checked)
    this.showMismatch(this.confirmationDiverged())
  }

  // On leaving the field a shorter, unfinished confirmation counts as a mismatch too.
  confirm() {
    this.check()
    if (this.hasConfirmationTarget && this.confirmationTarget.value) {
      this.showMismatch(this.confirmationTarget.value !== this.passwordTarget.value)
    }
  }

  passwordReady() {
    const password = this.passwordTarget.value
    if (!this.hasConfirmationTarget) return password.length > 0

    return PASSWORD_POLICY.test(password) && this.confirmationTarget.value === password
  }

  // While typing, only a confirmation that can no longer become the password is wrong.
  confirmationDiverged() {
    if (!this.hasConfirmationTarget) return false

    const confirmation = this.confirmationTarget.value
    return confirmation.length > 0 && !this.passwordTarget.value.startsWith(confirmation)
  }

  showMismatch(mismatched) {
    if (!this.hasMismatchTarget) return

    this.mismatchTarget.hidden = !mismatched
    this.confirmationTarget.setAttribute("aria-invalid", String(mismatched))
    this.confirmationTarget.closest(".app-input-group")?.classList.toggle("has-error", mismatched)
  }
}
